import { FaSignOutAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const AdminHeader = () => {
  const navigate = useNavigate();

  const handleLogOut = () => {
    localStorage.removeItem("userToken");
    localStorage.removeItem("userEmail");
    localStorage.removeItem("userLocation");
    localStorage.removeItem("name");
    localStorage.removeItem("location");
    localStorage.removeItem("username");
    localStorage.removeItem("isAdmin");
    localStorage.removeItem("userToken");
    localStorage.removeItem("userId");
    localStorage.removeItem("userName");
    localStorage.clear();

    navigate("/");
  };

  return (
    <header className="flex justify-between items-center p-5 bg-[#f8f8f8] shadow-[0_2px_4px_rgba(0,0,0,0.1)] relative max-[768px]:p-2.5">
      <img src="/logo.png" alt="Sports Hub Logo" className="h-10 max-[768px]:h-5" />
      <div className="flex items-center gap-4 max-[768px]:gap-0.5">
        <button
          onClick={handleLogOut}
          className="px-5 py-[5px] bg-[#e74c3c] text-white rounded-[5px] text-[14px] cursor-pointer transition-colors duration-300 hover:bg-[#c0392b] max-[768px]:px-2.5 max-[768px]:py-[3px] max-[768px]:text-[9px]"
        >
          <span className="inline-flex items-center gap-2"><FaSignOutAlt /> Log Out</span>
        </button>
      </div>
    </header>
  );
};

export default AdminHeader;
